import { BaseAPI } from './BaseAPI.js'
import { PauseCode } from '../types/index.js'

export default class PauseCodesAPI extends BaseAPI<PauseCode> {
  override get resource(): string {
    return '/pauseCodes'
  }
}
